import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi, type AdminOverview } from "../../api/admin";
import { StatusPill } from "../../components/StatusPill";
import { AdminEmpty, AdminError, AdminSkeleton } from "../../components/admin/AdminUi";

const metricLabels: Record<string, string> = {
  users_total: "总用户",
  users_active: "活跃用户",
  users_disabled: "已停用",
  credit_balance_total: "积分余额总量",
  tasks_total: "历史任务",
  tasks_active: "运行中任务",
  tasks_24h: "24h 新任务",
  success_items_24h: "24h 成功项",
  failed_items_24h: "24h 失败项",
  redeem_codes_available: "可用卡密",
};

export function AdminOverviewPage() {
  const [data, setData] = useState<AdminOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  function load() {
    setLoading(true);
    setError("");
    adminApi.overview().then(setData).catch((reason: unknown) => setError(reason instanceof Error ? reason.message : "无法加载管理总览")).finally(() => setLoading(false));
  }
  useEffect(load, []);
  if (loading && !data) return <AdminSkeleton rows={8} />;
  if (error && !data) return <AdminError message={error} retry={load} />;
  if (!data) return <AdminEmpty title="暂无管理数据" description="后端没有返回总览信息。" />;
  return (
    <div className="admin-page">
      <header className="admin-page__heading"><div><span>CONTROL PLANE</span><h2>运行总览</h2><p>用户、任务和队列的真实状态汇总。</p></div><button className="button button--quiet" disabled={loading} onClick={load}>{loading ? "刷新中" : "刷新"}</button></header>
      {error ? <AdminError message={error} retry={load} /> : null}
      <section className="admin-metric-grid">
        {Object.entries(metricLabels).map(([key, label]) => <article key={key}><span>{label}</span><b>{Number(data.metrics[key] || 0).toLocaleString()}</b><i /></article>)}
      </section>
      <div className="admin-overview-grid">
        <section className="admin-panel admin-queue-card">
          <header><div><span>QUEUE</span><h3>队列与 Worker</h3></div><StatusPill status={data.queue.status} /></header>
          <div className="admin-queue-numbers"><div><b>{data.queue.queued ?? "-"}</b><span>排队</span></div><div><b>{data.queue.busy_workers}</b><span>忙碌</span></div><div><b>{data.queue.worker_count}</b><span>Worker</span></div><div><b>{data.queue.failed ?? "-"}</b><span>失败注册</span></div></div>
          {data.queue.status !== "ok" ? <p className="admin-warning">队列连接已降级：{data.queue.error || "未知错误"}</p> : null}
          <Link className="text-link" to="/admin/diagnostics">打开运行诊断</Link>
        </section>
        <section className="admin-panel">
          <header><div><span>RECENT</span><h3>最近任务</h3></div><Link to="/admin/tasks">查看全部</Link></header>
          <div className="admin-compact-list">
            {data.recent_tasks.length ? data.recent_tasks.map((task) => <Link key={task.id} to={`/admin/tasks?task=${task.id}`}><b>#{task.id}</b><span>用户 {task.user_id}</span><StatusPill status={task.status} /><small>{task.success_count}/{task.total_count}</small></Link>) : <AdminEmpty title="暂无任务" description="任务创建后会出现在这里。" />}
          </div>
        </section>
      </div>
    </div>
  );
}

